import React, { useState } from 'react'
import { CheckBadgeIcon } from '@heroicons/react/24/outline'
import { AlerteNonClient } from './AlerteNonClient'
import { FirmTemplateProps } from '../firmTemplate'
import FirmMap from '../firm/map'
import { OfficesAddressesCard } from '../firm/OfficesAddressesCard'
import { Button } from '../../ui'
import { TeaserProps } from '../teaser'
import { OtherFirms } from '../firm/OtherFirms'

export const NonClientTemplate = ({
  constants,
  data,
  othersFirms = [],
}: {
  constants: FirmTemplateProps['constants']
  data: FirmTemplateProps['data']
  othersFirms: TeaserProps[]
}) => {
  const [focusedAddress, setFocusedAddress] = useState<{
    street: string
    city: string
    postalCode: string
  } | null>(null)

  return (
    <section className="w-full max-w-[500px] md:max-w-[1000px] xl:max-w-[1115px] lg:max-w-[950px] lg:mx-auto 2xl:max-w-[1320px] my-6 lg:mt-28 space-y-4 md:space-y-6 lg:space-y-16 mx-auto px-4 md:px-0">
      <div className="grid grid-cols-1 gap-4 md:gap-x-6 md:grid-cols-4">
        <AlerteNonClient firmUuid={data.uuid || ''} />
        <FirmMap
          offices={data.offices}
          googleMapsApiKey={constants.googleMapsApiKey || ''}
          focusedAddress={focusedAddress}
        />

        <OfficesAddressesCard
          offices={data.offices || []}
          setFocusedAddress={setFocusedAddress}
          additionalClasses="max-h-[396px]"
        />
      </div>

      <OtherFirms
        othersFirms={othersFirms}
        title="Des cabinets déjà référencés pourraient vous intéresser"
      />

      <div className="p-6 space-y-4 border rounded-lg lg:px-8 border-lamacompta-blue/70 md:space-y-6 text-night">
        <p>Vous représentez {data.name}&nbsp;?</p>
        <h2 className="text-lg font-bold md:text-left lg:text-2xl">
          Bénéficier des services de Lamacompta
        </h2>
        <FirmServices />
        <div>
          <Button
            color="primary"
            size="medium"
            label="Revendiquez le cabinet"
            invert
            href="https://calendar.google.com/calendar/u/0/appointments/schedules/AcZssZ0RlfsxIUqkWcZuJCKWM1_8C3CrK4zxa6iHD2x5KdJJqTDJ2jsrIQQeczMWUwE1V7bJTzoc-Oj7"
            isExternal
          />
        </div>
      </div>
    </section>
  )
}

const FirmServices = () => {
  const services = [
    'Soyez référencé sur Lamacompta',
    'Recevez des candidatures spontanées',
  ]
  return (
    <ul className="space-y-2">
      {services.map((service) => (
        <li key={service} className="flex items-center gap-2 space-x-2">
          <CheckBadgeIcon className="w-6 h-6" />
          <p>{service}</p>
        </li>
      ))}
    </ul>
  )
}
